export class Equipment {
    id: number;
    description: string;
    equipmentTypeId: string; //guid
}

export class EquipmentType {
    equipmentTypeId: string; //guid
    type: string;
}